module.exports = __webpack_public_path__ + "static/img/12.e0d2386.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/20/zh/12.png
// module id = SBtN
// module chunks = 0